<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication1"><div class="block-rw dedication-rw" id="dedication1"><p class="ded-rw" id="p43" style="text-align: center;"><span><span><em>To my beautiful and talented daughter-in-law, Randi,</em>
</span></span></p><p class="ded-rw" id="p44" style="text-align: center;"><span><span><em>Who uses her skills to teach very special students.</em>
</span></span></p><p class="ded-rw" id="p31"><span> </span></p><p class="ded-rw" id="p46" style="text-align: center;"><span><span><em>And to Tom, my forever love.</em>
</span></span></p></div></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s003-Dedication-01.vue?05d0b860